module.exports = ['$scope', 'sessionData', 'services', '$q', 'storage', '$http', 'modal', 'employee',
	function($scope, sessionData, services, $q, storage, $http, modal, employee) {

		$scope.selectedGroup = {};
		$scope.displayMessage = false;
		$scope.groupsLoaded = false;
		$scope.gettingPdf = false;
		$scope.modalHeader = "Select Group";
		$scope.modalText = "";

		$scope.downloadSbc = function(){
			if ($scope.selectedGroup.groupNumber && $scope.umi) {
				$scope.gettingPdf = true;
				var sbcUrl = 'https://' + window.location.host + '/eprsvc/x-services/secure/documents/v1/member/' +
						$scope.umi + '/' + $scope.selectedGroup.groupNumber + '/summary-of-benefits';

				$http.get(sbcUrl).then(
					function (response) {
						//isn't this the success callback...?
						console.error('Error: we got an unexpected response from the http get.');
					},
					function (error) {
						if (error && error.data && error.data.baseMessage && error.data.baseMessage.returnCodeDescription === 'DOCUMENTS-NOT-FOUND') {
							if (sessionData.employerInfo.brandName == 6008) {
								setModalText('ibcError');
							} else if (sessionData.employerInfo.brandName == 6009) {
								setModalText('ahnjError');
							} else {
								setModalText('error');
							}
						} else if (error && error.message) {
							// apparently if we get this far into dissecting this chimera, we just open the link in a window
							// to kick off downloading the pdf? Someone ask Phil
							window.location.href = sbcUrl;
							setTimeout(function() {
								modal.close();
							}, 3000);
						} else {
							setModalText('error');
						}
						$scope.gettingPdf = false;
					}
				);
			}
		};

		function setModalText(option) {
			$scope.displayMessage = true;
			switch (option) {
                case 'error':
                    $scope.modalText = 'Something seems to have gone wrong, please try again later!';
                    break;
                case 'ibcError':
                    $scope.modalText = 'We are sorry for the inconvenience.  Please contact Customer Service at ' +
                    	'1-800-ASK-Blue to obtain information regarding your summary of benefits and coverage.';
                    break;
                case 'ahnjError':
                    $scope.modalText = 'We are sorry for the inconvenience.  Please contact Customer Service at ' +
                    	'1-877-219-5453 to obtain information regarding your summary of benefits and coverage.';
                    break;
                case 'noPermission':
                    $scope.modalText = 'There are no eligible groups for this election.';
                    break;
                case 'noActiveGroups':
                    $scope.modalText = 'No active groups.';
                    break;
                case 'clear':
                    $scope.modalText = '';
                    break;
                default:
                    $scope.modalText = 'Something seems to have gone wrong, please try again later!';
            }
		}

		function findTheGroups(activeGroupNumbers) {
			if (!activeGroupNumbers.length) {
				$scope.modalHeader = "Error";
				setModalText('noActiveGroups');
				$scope.groupsLoaded = true;
				return;
			}

			employee.loadSummary($scope.umi).then(
				function(employee) {

					var agiPromises = activeGroupNumbers.reduce( function(prev, next) {
						var effectiveDate = services.eprsvc.additionalGroupInformation().getEffectiveDate(next, employee.data.subscriber);
						prev[next] = services.eprsvc.additionalGroupInformation({ 'groupNumber': next }).fetch(effectiveDate);
						return prev;
					}, {});

					$q.all(agiPromises).then(
						function(response){
							$scope.groupNumbersWithPlanAreaCode = Object.keys(response).map(
								function(groupNumber) {
									var planAreaCode =
										response[groupNumber] &&
										response[groupNumber].data &&
										response[groupNumber].data.payload &&
										response[groupNumber].data.payload.planAreaCode;

									return {
										groupNumber: groupNumber,
										planAreaCode: planAreaCode
									};
								}
							).filter(function(g) { return g.planAreaCode; }).map(function(g) { return g.groupNumber; });
						},
						function() {
							setModalText('error');
						}
					).finally(function() {
						$scope.groupsLoaded = true;
					});
				},
				function() {
					setModalText('error');
				}
			);
		}
		findTheGroups($scope.activeGroupNumbers);
	}
];
